import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-primary-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-film-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-black text-background-50">电影天堂</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-primary-200">
            聚合最新电影资源与专业影视资讯，覆盖多种电影类型，帮助你轻松发现与了解热门影片。
          </p>
        </div>

        <div>
          <h4 className="mb-4 flex items-center gap-2 font-heading text-sm font-bold text-background-50">
            <a href="/" className="hover:text-accent-400">导航</a>
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="transition-colors hover:text-accent-400">首页</Link></li>
            <li><Link to="/news" className="transition-colors hover:text-accent-400">影视资讯</Link></li>
            <li><Link to="/search" className="transition-colors hover:text-accent-400">搜索影片</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-accent-400">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 flex items-center gap-2 font-heading text-sm font-bold text-background-50">
            <a href="/" className="hover:text-accent-400">热门分类</a>
          </h4>
          <ul className="space-y-2.5 text-sm">
            {categories.slice(0, 6).map((c) => (
              <li key={c.slug}>
                <Link to={`/category/${c.slug}`} className="transition-colors hover:text-accent-400">
                  {c.name}电影
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 flex items-center gap-2 font-heading text-sm font-bold text-background-50">
            <a href="/about" className="hover:text-accent-400">联系与说明</a>
          </h4>
          <ul className="space-y-2.5 text-sm text-primary-200">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              contact@movie-paradise.demo
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line"></i>
              演示站点 · 内容均为虚构
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-information-line"></i>
              友情链接：影视观察 / 银幕笔记
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-300 sm:flex-row md:px-6">
          <p>© 2025 电影天堂 Movie Paradise · 本站内容均为演示用虚构样本</p>
          <p>仅用于产品演示，不提供任何真实资源下载</p>
        </div>
      </div>
    </footer>
  );
}